module.exports = __webpack_public_path__ + "img/deco-black-bg-white-line.58c81b14.svg";